const successModal = new bootstrap.Modal(document.getElementById('success-modal'))
const callbackModal = new bootstrap.Modal(document.getElementById('callback-modal'))
const purchaseModal = new bootstrap.Modal(document.getElementById('purchase-modal'))
const orderElement = document.getElementById('order-modal');
const orderModal = orderElement ? new bootstrap.Modal(orderElement) : null;

const messageTitleElement = document.getElementById('success-modal-title');
const messageTextElement = document.getElementById('success-modal-text');

function refreshFormToken(form, token) {
    let tokenInput = form.querySelector('[name="form_token"]');
    if (tokenInput && token) {
        tokenInput.value = token;
        tokenInput.defaultValue = token;
    }
}

document.addEventListener('click', function(event) {
    let btn = event.target.closest('.js-buy-modal');
    if (btn) {
        let type = btn.dataset.type;
        let title = btn.dataset.title;
        let typeElement = document.querySelector('.js-purchase-type');
        let titleElement = document.querySelector('.js-purchase-title');
        typeElement.value = type;
        titleElement.innerHTML = title;
        purchaseModal.show();
    }
});
document.addEventListener('submit', function(event) {
    let form = event.target.closest('.js-form');
    if (form) {
        event.preventDefault();
        url = form.getAttribute('action');
        let data = new FormData(form);
        if (form.checkValidity() === false) {
            form.classList.add('-error');
            return;
        }
        form.classList.remove('-error');
        axios.post(url, data)
            .then((response) => {
                let data = response.data;
                if (data.status == 'success') {
                    form.reset();
                    refreshFormToken(form, data.form_token);
                    messageTitleElement.innerHTML = 'Заявка отправлена!';
                    messageTextElement.innerHTML = 'В ближайшее время мы свяжемся с Вами';
                    callbackModal.hide();
                    purchaseModal.hide();
                    if (orderModal) {
                        orderModal.hide();
                    }
                    successModal.show();
                }
            })
            .catch(function(error) {
                console.log(error);
                callbackModal.hide();
                purchaseModal.hide();
                if (orderModal) {
                    orderModal.hide();
                }
                messageTitleElement.innerHTML = 'Что-то пошло не так :(';
                messageTextElement.innerHTML = 'Попробуйте позже';
                successModal.show();
            });
        return false;
    }
}, false);
